import { j as a } from "./atoms-v218.js";
import { calculatedTextSkeletonHOC as l } from "./atoms-v21172.js";
import { MonthLabel as n } from "./atoms-v21173.js";
import { useCalendarContext as m } from "./atoms-v2766.js";
function s({ colorTheme: e, monthConfig: o, yearValue: t }) {
  const { domBuilder: r } = m();
  return /* @__PURE__ */ a.jsxs(n, { $colorTheme: e, className: "layr-calendar-month-label", children: [
    r.text.months[o.value],
    " ",
    t
  ] });
}
const x = l(s);
export {
  x as CalendarMonthLabel,
  s as HOCCallback
};
